import { render, staticRenderFns } from "./UploaderPlaceholder.vue?vue&type=template&id=67e2cb88&scoped=true&"
import script from "./UploaderPlaceholder.vue?vue&type=script&lang=js&"
export * from "./UploaderPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./UploaderPlaceholder.vue?vue&type=style&index=0&id=67e2cb88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2cb88",
  null
  
)

export default component.exports